import { render, staticRenderFns } from "./TopLocations.vue?vue&type=template&id=667ba084&"
import script from "./TopLocations.vue?vue&type=script&lang=js&"
export * from "./TopLocations.vue?vue&type=script&lang=js&"
import style0 from "./TopLocations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports